import { Helmet } from "react-helmet";
import { FC } from "react";

import CommonLayout from "../../AccountPage/CommonLayout";
import ClientReservation from "../ClientReservation";

export interface AccountPageProps {
  className?: string;
}

const OwnerReservationPage: FC<AccountPageProps> = ({ className = "" }) => {
  return (
    <CommonLayout>
      <div
        className={`overflow-hidden relative nc-ListingFlightsPage ${className}`}
        data-nc-id="ListingFlightsPage"
      >
        <Helmet>
          <title>
            EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France
          </title>
        </Helmet>

        <div className=""></div>
      </div>
    </CommonLayout>
  );
};

export default OwnerReservationPage;
